module.exports = __webpack_public_path__ + "static/media/headerLogo.b07ca977.png";